import React, { Suspense } from 'react';
import Spinner from '../../components/spinner';

// Lazy-loaded components
const SpeechLanguagePathologyPageSession = React.lazy(() => import('../departments/speechlanguagepathology/SpeechLanguagePathologyPageSession'));
const SpeechLanguagePathologyPageHeader = React.lazy(() => import('../departments/speechlanguagepathology/SpeechLanguagePathologyPageHeader'));

function SpeechLanguagePathologyPage() {
  return (
    <div className="page-wrapper">
   
      {/* Suspense to handle lazy loading */}
      <Suspense fallback={<Spinner />} jsx={true.toString()}>
       <SpeechLanguagePathologyPageHeader />
       <SpeechLanguagePathologyPageSession />
      </Suspense>
    </div>
  );
}

export default SpeechLanguagePathologyPage;
